import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';

class RadioButtonField extends PureComponent {
  componentDidMount() {
    if (this.props.defaultChecked) {
      this.props.onChange(this.props.radioValue);
    }
  }

  onChange = () => {
    this.props.onChange(this.props.radioValue);
  };

  render() {
    const disabled = this.props.disabled;

    return (
      <label
        className={`radio-btn${disabled ? ' disabled' : ''}${
          this.props.class ? ` radio-btn--${this.props.class}` : ''
        }`}
      >
        <input
          className="radio-btn__radio"
          name={this.props.name}
          type="radio"
          onChange={this.onChange}
          checked={this.props.value === this.props.radioValue}
          disabled={disabled}
        />
        <span className="radio-btn__radio-custom" />
        <span className="radio-btn__label">{this.props.label}</span>
      </label>
    );
  }
}

const renderRadioButtonField = props => (
  <RadioButtonField
    {...props.input}
    label={props.label}
    defaultChecked={props.defaultChecked}
    disabled={props.disabled}
    radioValue={props.radioValue}
    class={props.class}
  />
);

renderRadioButtonField.propTypes = {
  input: PropTypes.object.isRequired,
  label: PropTypes.node,
  defaultChecked: PropTypes.bool,
  disabled: PropTypes.bool,
  radioValue: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.bool,
    PropTypes.number
  ]),
  class: PropTypes.string
};

export default renderRadioButtonField;



// WEBPACK FOOTER //
// ./src/components/formFields/RadioButton.js